import React, { Component } from 'react';

import { FormErrors } from './FormErrors';

import 'video.js/dist/video-js.css';
import videojs from 'video.js';

import 'webrtc-adapter';
import RecordRTC from 'recordrtc';

// register videojs-record plugin with this import
import 'videojs-record/dist/css/videojs.record.css';
import Record from 'videojs-record/dist/videojs.record.js';

import axios from 'axios';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deviceReady: false,
      videoSubmitted: false,
      startRecordingClicked: false,
      recordingStarted: false,
      recordingStoppped: false,
      showRecorder: false,
      finishedRecording: false,
      submittingVideo: false,
      file_upload_name: 'Choose file',
      upload_type: '',
      name: '',
      email: '',
      formErrors: {
        name: '',
        email: ''
      },
      intialFormSubmitted: false,
      nameValid: false,
      emailValid: false,
      time: {}, 
      seconds: 6,
      submitMessage: {},
      uploadErrorMessage: null,
      validDuration: false,
      validVideoDuration: 120,
      isIOS: false,
      isSafari: false
    }
    this.timer = null;
    this.startTimer = this.startTimer.bind(this);
    this.countDown = this.countDown.bind(this);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleUserInput = this.handleUserInput.bind(this);
    this.handleStarRecording = this.handleStarRecording.bind(this);
    this.handleSubmitVideo = this.handleSubmitVideo.bind(this);
    this.handleUploadVideo = this.handleUploadVideo.bind(this);
    this.handleStopRecording = this.handleStopRecording.bind(this);
    this.handleResetRecording = this.handleResetRecording.bind(this);
    this.isValidFileUploaded = this.isValidFileUploaded.bind(this);
    this.fileChange = this.fileChange.bind(this);
    this.errorClass = this.errorClass.bind(this);
    this.validateField = this.validateField.bind(this);
    this.recorderRef = React.createRef();
    this.validFileUpload = false;
    this.validFileUploadSize = false;
    this.fileUpload = null;
    this.fileUploadSubmitted = false;
    this.isUploadingVideo = false;
  }

  startTimer() {
    if (this.timer == null && this.state.seconds > 0) {
      this.timer = setInterval(this.countDown, 1000);
    }
  }

  countDown() {
    // Remove one second, set state so a re-render happens.
    let seconds = this.state.seconds - 1;
    this.setState({
      time: this.secondsToTime(seconds),
      seconds: seconds,
    });
    
    // Check if we're at zero.
    if (seconds == 0) { 
      clearInterval(this.timer);
      this.player.record().start();
    }
  }

  secondsToTime(secs){
    let hours = Math.floor(secs / (60 * 60));

    let divisor_for_minutes = secs % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);

    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = Math.ceil(divisor_for_seconds);

    let obj = {
      "h": hours,
      "m": minutes,
      "s": seconds
    };
    return obj;
  }

  componentDidMount() {
    const that = this;
    // instantiate Video.js
    if (this.videoNode) {

      this.player = videojs(this.videoNode, this.props, () => {
        // print version information at startup
        const version_info = 'Using video.js ' + videojs.VERSION +
            ' with videojs-record ' + videojs.getPluginVersion('record') +
            ' and recordrtc ' + RecordRTC.version;
        //videojs.log(version_info);
      });
  
      // device is ready
      this.player.on('deviceReady', () => {
        that.setState({
          deviceReady: true
        });
        this.recorderRef.current.scrollIntoView();
      });
  
      // user clicked the record button and started recording
      this.player.on('startRecord', () => {
        // console.log('started recording!');
        that.setState({
          recordingStarted: true
        });
      });
  
      // user completed recording and stream is available
      this.player.on('finishRecord', () => {
        this.setState({
          finishedRecording: true,
          recordingStoppped: true
        });
      });
  
      // error handling
      this.player.on('error', (element, error) => {
        console.warn(error);
      });
  
      this.player.on('deviceError', () => {
        this.setState({
          submitMessage: {
            message: this.player.deviceErrorCode.message,
            type: 'error'
          }
        })
      });

    }
    let showWebkitError = false;

    var isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    this.setState({
      isIOS: iOS,
      isSafari: isSafari
    });

    if(/CriOS/i.test(navigator.userAgent) && /iphone|ipod|ipad/i.test(navigator.userAgent)) {
      showWebkitError = true;
    }

    if (showWebkitError) {
      if (document.querySelector('#form-section .bottom h3')) {
        document.querySelector('#form-section .bottom h3').style.display = 'none';
      }
      if (document.querySelector('#record-video .bottom h3')) {
        document.querySelector('#record-video .bottom h3').style.display = 'none';
      }
    }
  }

  validateField(fieldName, value) {
    let fieldValidationErrors = this.state.formErrors;
    let emailValid = this.state.emailValid;
    let nameValid = this.state.nameValid;

    switch(fieldName) {
      case 'email':
        emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        fieldValidationErrors.email = emailValid ? '' : ' is invalid';
        break;
      case 'name':
        nameValid = value !== '';
        fieldValidationErrors.name = nameValid ? '': ' is required';
        break;
      default:
        break;
    }
    this.setState({formErrors: fieldValidationErrors,
      emailValid: emailValid,
      nameValid: nameValid
    }, this.validateForm);
  }

  errorClass(error) {
    return(error.length === 0 ? '' : 'has-error');
  }

  // destroy player on unmount
  componentWillUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    const { nameValid, emailValid } = this.state;
    if (!nameValid || !emailValid) {
      this.setState({
        intialFormSubmitted: true
      });
      return false;
    }

    this.setState({
      intialFormSubmitted: true,
      showRecorder: true
    });
    if (typeof this.player !== 'undefined') {
      this.player.record().getDevice();
    }
  }

  handleUserInput(e, key) {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({
      [name]: value
    }, () => { this.validateField(name, value) });
  }

  handleStarRecording() {
    this.startTimer();
    this.setState({
      startRecordingClicked: true
    });
  }

  handleStopRecording() {
    this.player.record().stop();
    this.setState({
      recordingStoppped: true
    });
  }

  handleResetRecording() {
    this.player.record().reset();
    this.player.record().getDevice();
    this.timer = null;
    this.setState({
      time: {}, 
      seconds: 6,
      startRecordingClicked: false,
      recordingStarted: false,
      recordingStoppped: false
    });
  }

  handleSubmitVideo() {
    const { finishedRecording } = this.state;
    const that = this;
    if (!finishedRecording) {
      return;
    }

    this.setState({
      submittingVideo: true
    });
    var data = new FormData();
    // console.log(this.player.recordedData);
    data.append('_token', document.querySelector('[name="csrf-token"]').getAttribute('content'));
    data.append('name', this.state.name);
    data.append('email', this.state.email);
    data.append('file', this.player.recordedData);

    axios.post('/ugc/video/upload', data, {
      'Content-Type': 'multipart/form-data'
    }).then(function(response){
      that.setState({
        submittingVideo: false,
        finishedRecording: false,
        showRecorder: false,
        videoSubmitted: true,
        name: '',
        email: '',
        submitMessage: {
          message: response.data
        }
      });
      that.player.record().reset();
    }).catch(function(error){
      that.setState({
        submittingVideo: false
      });
    });
  }

  handleUploadVideo() {
    const { validFileUpload } = this.state;
    const that = this;
    this.setState({
      fileUploadSubmitted: true
    });
  
    if (!validFileUpload) {
      return;
    }

    this.setState({
      submittingVideo: true,
      isUploadingVideo: true,
      uploadErrorMessage: null
    });
    var data = new FormData();
    // console.log(this.player.recordedData);
    data.append('_token', document.querySelector('[name="csrf-token"]').getAttribute('content'));
    data.append('upload_type', this.state.upload_type);
    data.append('name', this.state.name);
    data.append('email', this.state.email);
    data.append('file', this.state.fileUpload);

    axios.post('/ugc/video/upload', data, {
      'Content-Type': 'multipart/form-data'
    }).then(function(response){
      that.setState({
        submittingVideo: false,
        finishedRecording: false,
        showRecorder: false,
        videoSubmitted: true,
        name: '',
        email: '',
        submitMessage: {
          message: response.data
        },
        isUploadingVideo: false
      });
      that.player.record().reset();
    }).catch(function(error){
      let response = error.response;
      if (response.hasOwnProperty('data') && response.data.hasOwnProperty('message')) {
        that.setState({
          uploadErrorMessage: response.data.message
        })
      }
      that.setState({
        submittingVideo: false,
        isUploadingVideo: false
      });
    });
  }

  isValidFileUploaded(file) {
    const validExtensions = ['mp4','mov','avi', 'wmv','flv','quicktime'];
    const fileExtension = file.type.split('/')[1];
    return validExtensions.includes(fileExtension.toLowerCase());
  }

  isValidFileSize(file) {
    const MAX_FILE_SIZE = 300000 // 5MB
    const fileSizeKiloBytes = file.size / 1024;

    this.setState({
      uploadErrorMessage: ''
    });

    if(fileSizeKiloBytes > MAX_FILE_SIZE){
      this.setState({
        uploadErrorMessage: 'Video is too large. Maximum file size is 300MB.'
      });
      return false;
    }

    return true;
  }

  isValidFileDuration = async(file) => {
    let that = this;
    var video = document.createElement('video');
    video.preload = 'metadata';
    const {validDuration, validVideoDuration} = this.state;
    video.src = URL.createObjectURL(file);

    return video.onloadedmetadata = function () {
      window.URL.revokeObjectURL(video.src);
      if (video.duration > validVideoDuration) {
        return false;
      } else {
        return true;
      }
    };

  }

  fileChange(e) {
    let that = this;
    if(e.target.files.length < 1){
      return;
    }

    this.setState({
      uploadErrorMessage: null
    })

    const file = e.target.files[0];
    this.setState({
      file_upload_name: file.name
    });

    var video = document.createElement('video');
    video.preload = 'metadata';
    const {validDuration, validVideoDuration} = this.state;
    video.src = URL.createObjectURL(file);

    video.onloadedmetadata = function () {
      window.URL.revokeObjectURL(video.src);
      if (video.duration > validVideoDuration) {
        that.setState({
          validDuration: false,
          uploadErrorMessage: 'Video is too long. Maximum video duration is 2 minutes.'
        });
      } else {
        if(that.isValidFileUploaded(file)){
          that.setState({
            validDuration: true,
            validFileUpload: true,
            fileUpload: file,
            upload_type: 'manual'
          });
        }
      }
    };
  }
  
  render() {
    const { 
      showRecorder,
      submittingVideo,
      submitMessage,
      videoSubmitted,
      deviceReady,
      recordingStarted,
      recordingStoppped,
      startRecordingClicked,
      intialFormSubmitted,
      nameValid,
      emailValid,
      fileUploadSubmitted,
      validFileUpload,
      isUploadingVideo,
      uploadErrorMessage,
      isIOS,
      isSafari
     } = this.state;
      
    let recordButton = '';
    let stopRecording = '';
    let submitRecording = '';
    let submittingVideoLoader = '';
    let nameError = '';
    let emailError = '';
    let submitMessageContent = '';
    let timer = this.state.time.s;
    let showWebkitError = false;

    if(/CriOS/i.test(navigator.userAgent) && /iphone|ipod|ipad/i.test(navigator.userAgent)) {
      showWebkitError = true;
    }

    if (isIOS && isSafari) {
      // showWebkitError = true;
      showWebkitError = false;
    }

    if (deviceReady && !startRecordingClicked) {
      recordButton = (<div className='cp-ugc--custom-controls cp-ugc--start text-center'><div className='inner'><button onClick={this.handleStarRecording} className='btn btn-primary btn-primary-record'><img width="22" height="22" src="/img/icons/icon-record.svg" alt="" /> Start Recording</button></div></div>);
    }

    if (recordingStarted && !recordingStoppped) {
      stopRecording = (<div className='cp-ugc--custom-controls cp-ugc--stop'><div className='inner'><button onClick={this.handleStopRecording} className='btn btn-primary btn-primary-stop-record'><img width="22" height="22" src="/img/stop-solid.svg" alt="" /> Finish Recording</button></div></div>);
    }
    
    if (recordingStarted && recordingStoppped) {
      submitRecording = (
      <div className='cp-ugc--custom-controls cp-ugc--submit'>
        <div className='inner'>
          <div className='btn-wrap'>
            <button onClick={this.handleResetRecording} className='btn btn-primary btn-primary-re-record'><img width="22" height="22" src="/img/arrows-rotate-solid.svg" alt="" /> Re-Record Video</button>
          </div>
          <div className='btn-wrap'>
            <button onClick={this.handleSubmitVideo} className='btn btn-primary btn-primary-submit'><img width="22" height="22" src="/img/icons/icon-upload.svg" alt="" /> Submit Video</button>
          </div>
        </div>
      </div>);
    }

    if (submittingVideo) {
      submittingVideoLoader = (<div className='cp-ugc--submitting'><div className='loader'></div></div>);
    }

    if ((intialFormSubmitted) && !nameValid) {
      nameError =  (<label className='error'>Name is required.</label>);
    }

    if ((intialFormSubmitted) && !emailValid) {
      emailError =  (<label className='error'>Please enter a valid Email Address.</label>);
    }

    let submitMessageContentClass = 'alert alert-success text-center';

    if (submitMessage.hasOwnProperty('message')) {
      if (submitMessage.hasOwnProperty('type')) {
        if (submitMessage.type == 'error') {
          submitMessageContentClass = 'alert alert-danger text-center';
        }
      }
      submitMessageContent = (<div className='cp-ugc--result-msg'><div className={ submitMessageContentClass }>{ submitMessage.message }</div></div>);
    }

    const modalTermsAndConditions = (<div className="modal fade" id="termsAndCondition" tabIndex="-1" role="dialog" aria-labelledby="termsAndConditionCenterTitle" aria-hidden="true">
    <div className="modal-dialog modal-dialog-centered" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <button type="button" className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="content-title text-center">
            <h3>Terms And Conditions</h3>
          </div>
  
          <div className="content-content">
            <ol>
              <li>By submitting this form you will be required to provide your personal details as well as record details of your experience with this product and service. All information provided must:
                <ol>
                  <li>be accurate and correct to the best of your knowledge; and</li>
                  <li>not infringe on the rights of any third parties, including but not limited to, content that infringes on privacy rights or intellectual property rights, such as copyright and trademark rights.</li>
                </ol>
              </li>
              <li>In order to submit this form, you must be over the age of 19.</li>
              <li>The information submitted on this website including, without limitation, video, audio, photographs, images, information, data, text shall be referred to below as "Content". For Content uploaded by you, or given to us, you grant us a non-exclusive, transferable, irrevocable, sub-licensable, royalty-free, perpetual worldwide license for its use in any lawful purpose whatsoever, including the right to use, reproduce, edit, exhibit, project, display, copyright, publish and stream for commercial or non-commercial means (the “Content License”). Any monetary rewards or free product you receive is exclusively to compensate you for the Content License and the waiving of any copyrights that you have in relation to the Content.</li>
              <li>You may not do any of the following while accessing or using this website or its services:
                <ol>
                  <li>access, tamper with, or use non-public areas of the computer or delivery systems;</li>
                  <li>probe, scan, or test any system or network (particularly for vulnerabilities), or otherwise attempt to breach or circumvent any security or authentication measures;</li>
                  <li>interfere with, or disrupt, (or attempt to do so), the access of any user, host or network, including, without limitation, by sending a virus to, spamming, or overloading the service, or by scripted use of the services in such a manner as to interfere with or create an undue burden on the services;</li>
                  <li>take any action that may undermine the service or this website.</li>
                </ol>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </div>);

    let button_cta_text = 'Start Recording';
    if (showWebkitError) {
      button_cta_text = 'Continue';
    }

    const formQuestion = (<form autoComplete='on' noValidate onSubmit={this.handleSubmit} className={ (videoSubmitted ? 'hidden ' : ' ') + (!showRecorder ? 'show' : 'hidden') + ' cp-ugc--form' }>
    <div className='cp-ugc--form-inner'>

      <div className={`form-group ${this.errorClass(this.state.formErrors.name)}`}>
        <label>Your Name</label>
        <input autoComplete='on' onChange={(event) => this.handleUserInput(event, 'name')} type="text" id="name" name='name' className='form-control' required/>
        { nameError }
      </div>
      <div className={`form-group ${this.errorClass(this.state.formErrors.email)}`}>
        <label>Your Email</label>
        <input autoComplete='on' onChange={(event) => this.handleUserInput(event, 'email')} type="email" id="email" name='email' className='form-control' required/>
        { emailError }
      </div>
      <div className='form-note'>
        <p>*All fields are required to submit your video</p>
      </div>
      <div className='form-action text-center'>
        <button className='btn btn-primary'>{button_cta_text}</button>
      </div>
    </div>
    <div className='cp-ugc--form-terms text-center'>
      <p className='mb-0'>By continuing to record a video, you agree to the <a data-toggle="modal" data-target="#termsAndCondition">Terms of Service</a> and Privacy Policy.</p>
    </div>
    <div style={{display: 'none', height: '0', opacity: '0', visibility: 'hidden'}}>
    <input type='text' name='first_name' />
    <input type='text' name='last_name' />
    <input type='text' name='city' />
    <input type='text' name='zip' />
    <input type='text' name='postal' />
    </div>
    </form>);

    let formRecorder = (<div ref={this.recorderRef} className={ ((submittingVideo) ? 'submitting' : '') + ' cp-ugc--record video-recorder-wrapper' }>
      <div>
        <div className={ (timer === 0 ? 'hidden' : '') + ' start-timer'}>{this.state.time.s}</div>
        { submittingVideoLoader }
        { recordButton }
        <div data-vjs-player>
          <video id="recordVideo" ref={node => this.videoNode = node} className="video-js vjs-default-skin" playsInline></video>
        </div>
        <div className='cp-ugc--custom-controls-wrap'>
          { stopRecording }
          { submitRecording }
        </div>
      </div>
    </div>);

    let fileUploadError = '';
    if (fileUploadSubmitted && !validFileUpload && uploadErrorMessage == null) {
      fileUploadError = (<div className="alert alert-danger">Please select a valid video file.</div>);
    }

    let showUploadErrorMessage = '';
    if (uploadErrorMessage !== null) {
      showUploadErrorMessage = (<div className="alert alert-danger">{uploadErrorMessage}</div>);
    }

    let uploadingClass = '';
    if (isUploadingVideo) {
      uploadingClass = 'uploading'
    }

    let formRecorderClassList = ['submitting','cp-ugc--record','video-recorder-wrapper'];
    if (videoSubmitted) {
      formRecorderClassList.push('hidden');
    }

    let formRecorderClass = formRecorderClassList.join(' ');

    if (showWebkitError) {
      formRecorder = (
        <div className={ formRecorderClass }>
          <div className="cp-ugc--form py-5">
            <div className="text-center no-recorder-error"><p>We're sorry, recording in iPhone/iPads using Chrome are currently not supported.</p><p>Please upload a video file using the form below:</p></div>
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text" id="fileuploadLbl">Upload</span>
              </div>
              <div className="custom-file">
                <input onChange={this.fileChange.bind(this)} type="file" name="file" className="custom-file-input" id="fileupload" aria-describedby="fileuploadLbl" />
                <label className="custom-file-label" htmlFor="fileupload">{this.state.file_upload_name}</label>
              </div>
            </div>
            <small className="form-text text-muted  mb-3">Maximum video duration is 2 minutes.</small>
            { fileUploadError }
            { showUploadErrorMessage }
            <div className="form-action text-center">
              <button disabled={isUploadingVideo} className={uploadingClass + ' btn btn-primary'} onClick={this.handleUploadVideo}>Upload Recording</button>
            </div>
          </div>
        </div>
      );
    }

    let recorderError = (<div className="text-center no-recorder-error"><p>We're sorry, iPhone/iPads using Chrome are currently not supported. Please open this link in Safari instead to submit your video and claim your reward.</p> <p className="mb-1 mb-lg-2">Link to copy:</p> <p className="link">{ 'https://' + location.hostname + location.pathname }</p></div>);

    let recorderContent = (<>
      { submitMessageContent }
      { formQuestion }
      { formRecorder }
      { modalTermsAndConditions }
    </>);
    // if (showWebkitError) {
    //   recorderContent = recorderError;
    // }

    return (
      <div className='cp-ugc' cp-ugc-root="true">
        { recorderContent }
      </div>
    );
  }
}

export default App;